import axios from 'axios';
import { apiUrl} from'../Config/Config';

const mem_plan = () => {
    let planLists = [];
    axios.post(apiUrl+"membership/plantypes").then(res => {
        if(res.data.status == "success"){
            let i=0;
            let planlist = res.data.planlist;
            
            for(i; i<planlist.length; i++){
                planLists[i] = { value: planlist[i]['id'], label: planlist[i]['title'] };
            }
            
        }       
    });
    return planLists;
}

const categories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}

const adcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"advertisement/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const cardCategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"creditcard/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const insuranceCategories = () => {
     var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"insurance/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const guidecategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidecategory/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const guidesubcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidesubcategory/sub_categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['sub_cate_name'] };
            }
            
        }       
    });
    return catelists;
}

const categories1 = () => {
    var qs = require('qs');

    var postobject = {
        type: 'all'
    };

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}


const year_list = () => {

    let years = [];  
    let start_yr = 1950;
    let end_yr = new Date().getFullYear();
    let diff = end_yr - start_yr;
    // console.log(end_yr, 'end_yr');
    // console.log(diff, 'diff');
    let i=0;
    for(i; i<=diff; i++){
        let opt = start_yr + i;
        years[i] = { value: opt, label: opt };
    }
    return years;
}
const domainList = () => {
    let domainlist = [];
    axios.post(apiUrl+"user/domainlist").then(res => {
        if(res.data.status == "success"){
            let i=0;
            let domainlists = res.data.domainlist;
            
            for(i; i<domainlists.length; i++){
                domainlist[i] = { value: domainlists[i]['domain_id'], label: domainlists[i]['domain_name'] };
            }
            
        }       
    });
   
    return domainlist;
}
export const lang = {

    common: {
        title:'Fund',
        status_option:[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
        ],
        membership_option_for:[
            { value: 'lender', label: 'Lender' },
            { value: 'broker', label: 'Broker' },
            { value: 'merchant', label: 'Merchant' },
        ],
        amounttype_option:[
            { value: 'merchant', label: 'Merchant' },
            { value: 'enterprises', label: 'Enterprises' },
        ],
        pluginWidth_option:[
            { value: '600', label: '600px' },
            { value: '700', label: '700px' },
            { value: '800', label: '800px' },
            { value: '900', label: '900px' },
            { value: '1000', label: '1000px' },
        ],
         pluginPosition :[
        { value: 'fixed', label: 'Fixed' },       
        { value: 'absolute', label: 'Absolute' }
        ],
       landingPageOptions :[
       // { value: 'MainTab', label: 'Main' },
        { value: 'AI Screen', label: 'AI Screen' },
        { value: 'InnerTab', label: 'Inner Tab' },       
        { value: 'LeadForm', label: 'Lead form' },
        { value: 'Ads', label: 'Ads' }
        ],
        chat_module_option:[
            { value: 'gpt-4o', label: 'gpt-4o' },
            { value: 'gpt-4', label: 'gpt-4' },
            { value: 'gpt-4-turbo', label: 'gpt-4-turbo' },
            { value: 'gpt-3.5', label: 'gpt-3.5' },
            { value: 'gpt-3.5-turbo', label: 'gpt-3.5-turbo' },
        ],
        gender_option: [
            { value: 'Male', label: 'Male' },
            { value: 'Female', label: 'Female' }
        ],
        period_option: [
            // { value: 'Day', label: 'Day' },
            { value: 'Month', label: 'Month' },
            { value: 'Year', label: 'Year' }
        ],
        mem_plan_option: mem_plan(),
        categories_option: categories(),
        adcategories_option: adcategories(),
        guidecategories_option: guidecategories(),
        guidesubcategories_option: guidesubcategories(),
        categories_option1: categories1(),
        year_option: year_list(),
        cardCategories_option:cardCategories(),
        insuranceCategories_option:insuranceCategories(),
        businessTime: [
            { value: '6', label: 'Less than 6 months' },
            { value: '12', label: '6-12 months' },
            { value: '24', label: '1 year' },
            { value: '60', label: '2-3 years' },
            { value: '90', label: '3-5 years' },
            { value: '120', label: 'More than 5 years' }
        ],
        // [
        //     // { value: 'Day', label: 'Day' },
        //     { value: '1', label: 'Plan 1' },
        //     { value: '2', label: 'Plan 2' },
        //     { value: '3', label: 'Plan 3' }
        // ],
		/* image_size_option: [
            { value: '250x250', label: '250x250' },
			{ value: '350x350', label: '350x350' },
            { value: '520x520', label: '520X520' }
        ],*/
        image_size_option: [
            { value: '1031x400', label: '1031x400 (W X H)' },
            { value: '250x180', label: '250x180 (W X H)' },
			{ value: '200x150', label: '200x150 (W X H)' },
            { value: '180x120', label: '180x120 (W X H)' }
        ],
        coming_source :[
            { value: '0', label: 'Select' },
            { value: 'friends', label: 'Friends' },
            { value: 'facebook', label: 'Facebook' },
            { value: 'instagram', label: 'Instagram' },
            { value: 'messaging apps', label: 'Messaging Apps' },
            { value: 'website', label: 'Website' },
            { value: 'flyers', label: 'Flyers' },
            { value: 'sms', label: 'Sms' },
            { value: 'newspaper', label: 'Newspapers' },
            { value: 'others', label: 'Others' }
        ],
         input_field_options :[
            { value: 'text', label: 'Text' },
            { value: 'email', label: 'Email' },
            { value: 'tel', label: 'Tel' },
            { value: 'textarea', label: 'Textarea' },
            { value: 'password', label: 'Password' },
            { value: 'select', label: 'Selectbox' },
            { value: 'checkbox', label: 'Checkbox' },
            { value: 'radio', label: 'Radio' },
            { value: 'url', label: 'url' },
            { value: 'image', label: 'Image' },
            { value: 'dynamic-dropdown', label: 'Dynamic Dropdown' },
        ],
       table_for :[
            { value: 'fund_form', label: 'Fund Form'},
            { value: 'user_login', label: 'User Login'},            
        ],
        user_table_columns :[
            { value: 'firstname', label: 'Firstname' },
            { value: 'lastname', label: 'Lastname' },
            { value: 'email', label: 'Email' },
            { value: 'mobileno', label: 'Mobileno' },
            { value: 'full_address', label: 'Full Address' },
            { value: 'zipcode', label: 'Zipcode' },
        ],
        quote_table_columns :[
            { value: 'firstname', label: 'firstname' },
            { value: 'lastname', label: 'lastname' },
            { value: 'email', label: 'email' },
            { value: 'mobileno', label: 'mobileno' },
            { value: 'full_address', label: 'full_address' },
            { value: 'zipcode', label: 'zipcode' },
            { value: 'business_module', label: 'business_module' },
            { value: 'business_name', label: 'business_name' },
            { value: 'fund_required', label: 'fund_required' },
            { value: 'business_category', label: 'business_category' },
            { value: 'loan_type', label: 'loan_type' },
            { value: 'business_type', label: 'business_type' },
            { value: 'business_time', label: 'business_time' },
            { value: 'annual_revenue', label: 'annual_revenue' },
            { value: 'funder_type', label: 'funder_type' },
            { value: 'ss_number', label: 'ss_number' },
            { value: 'fund_required_within', label: 'fund_required_within'},
            { value: 'fund_for', label: 'fund_for'},
        ],
        frontend_default_lable_option :[
            { value: 'annual-revenue', label: 'Annual Revenue' },
            { value: 'purpose', label: 'Purpose' },
            { value: 'funding-timeline', label: 'Funding Timeline' },          
           
        ],
		field_options :[
            {value:'applicationFormSt', label:'Guest Loan Application Form', type:"guest"},
            {value:'commonMembershipPage', label:'Guest Membership Page', type:"guest"},
            {value:'users_resquestList', label:'Guest Lead Page', type:"guest"},

            {value:'applicationFormSt', label:'Merchant Loan Application Form', type:"user"},
            {value: 'membershipPage', label: 'Merchant`s membership page', type: 'user'},
            // { value: 'showUsersAppList', label: 'User`s request', type: 'user'},
            // { value: 'showLeadResponse', label: 'User`s lead response', type: 'user'},
            // { value: 'showCreditCheck', label: 'Credit check', type: 'user'},
            // { value: 'showUploadDocuments', label: 'User`s upload documents', type: 'user'},
            // { value: 'showUserstheAdditionalform', label: 'User`s complete loan form', type: 'user'},
            // { value: 'lenderMainTab', label: 'Lender Main Tab',type: 'user'},
            // { value: 'leadMainTab', label: 'Lead Main Tab',type: 'user'},
            // { value: 'investorMainTab', label: 'Investor Main Tab', type: 'user'},

            { value: 'showUsersAppList', label: 'Investor`s Leads',type: 'investor'},
            { value: 'showInterests', label: 'Investor`s Interests',type: 'investor'},
            { value: 'showInvLender', label: 'Investor`s My lenders',type: 'investor'},
            { value: 'showInvRequest', label: 'Investor`s Lenders Request',type: 'investor'},
            { value: 'showInviteLender', label: 'Investor`s Lenders Invitation',type: 'investor'},
            
            { value: 'showUsersAppList', label: 'Lender`s Buy Leads',type: 'lender'},
            { value: 'showMyInvestors', label: 'Lender`s My Investor',type: 'lender'},
            { value: 'showArchived', label: 'Lender`s Archived',type: 'lender'},
            { value: 'showMyLeadRequest', label: 'Lender`s Lead',type: 'lender'},
            { value: 'showTransaction', label: 'Lender`s History',type: 'lender'},

            { value: 'showUsersList', label: 'Company`s Users list',type: 'company'},
            { value: 'showLeadsList-all', label: 'Company`s Leads list',type: 'company'},
            { value: 'showLeadsList-sold', label: 'Company`s Sold Lead',type: 'company'},
            { value: 'showLeadsList-funded', label: 'Company`s Funded Lead',type: 'company'},
            { value: 'showAllInvestors', label: 'Company`s All Investors',type: 'company'},
            { value: 'showLendersList-active', label: 'Company`s Lenders Active',type: 'company'},
            { value: 'showLendersList-inactive', label: 'Company`s Lenders Inactive',type: 'company'},
            { value: 'showTransactionsList', label: 'Company`s Monthly Earnings',type: 'company'},
            { value: 'showTransactionsList', label: 'Company`s Yearly Earnings',type: 'company'},
            { value: 'showTransactionsList', label: 'Company`s Purchased Leads',type: 'company'},
            //{ value: 'showMyInterests', label: 'My interests'},            
        ],
		dashboard_page_options :[
            { value: 'leadResponse', label: 'User`s lead response', type: 'Merchant'},
            { value: 'users_resquestList', label: 'User`s request', type: 'Merchant'},
            { value: 'creditChecks', label: 'Credit check', type: 'Merchant'},
            { value: 'showUserUnderWritingSt', label: 'Underwriting Process', type: 'Merchant'},
            { value: 'onlineUserSt', label: 'Online Users', type: 'Merchant'},
           // { value: 'userApplyForm', label: 'Loan application form', type: 'Merchant'},
            { value: 'applicationFormSt', label: 'Loan application form', type: 'Merchant'},
            { value: 'showFinancialSettings', label: 'AI Settings', type: 'Merchant'},
            { value: 'enablemanagepayments', label: 'Payment Methods', type: 'Merchant'},
            { value: 'showRepaymentTrackingSt', label: 'Loan Details', type: 'Merchant'},
            { value: 'showMyMatchupsPage', label: 'My Enquiry', type: 'Merchant'},
            { value: 'purchasedResponse', label: 'Purchased Response', type: 'Merchant'},
            { value: 'userProfileSt', label: 'User Profile', type: 'Merchant'},
            { value: 'enableUserList', label: 'User Inbox', type: 'Merchant'},
            { value: 'BankstatementSt', label: 'Bank Statement', type: 'Merchant'},
            { value: 'CreditcardrequestSt', label: 'Credit Card Request', type: 'Merchant'},
            { value: 'InsurancerequestSt', label: 'Insurance Request', type: 'Merchant'},
            { value:'membershipPage', label:'Membership Page', type: 'Merchant'},
            { value: 'archiveNotificationSt', label: 'Merchnant`s  Notifications', type: 'Merchant'},

            // { value: 'lenderMainTab', label: 'Lender Main Tab', type: 'Merchant'},
            // { value: 'leadMainTab', label: 'Lead Main Tab', type: 'Merchant'},
            //{ value: 'investorMainTab', label: 'Investor Main Tab', type: 'Merchant'},

            { value: 'users_resquestList', label: 'Investor`s Leads', type: 'Investor'},
            { value: 'showInterestPage', label: 'Investor`s Interests', type: 'Investor'},
            { value: 'showInvLenderPage', label: 'Investor`s My lenders', type: 'Investor'},
            { value: 'showMyInvRequestPage', label: 'Investor`s Lenders Request', type: 'Investor'},
            { value: 'showInviteLenderPage', label: 'Investor`s Lenders Invitation', type: 'Investor'},
            { value: 'investorBankStatementPage', label: 'Investor`s Bank Statement', type: 'Investor'},
            { value: 'onlineUserSt', label: 'Investor`s Online Users', type: 'Investor'},
            
            
            { value: 'enableprofile', label: 'Lender`s Profile', type: 'Lender'},
            { value: 'users_resquestList', label: 'Lender`s Buy Leads', type: 'Lender'},
            { value: 'showMyInvestorsPage', label: 'Lender`s My Investor', type: 'Lender'},
            { value: 'my_archive', label: 'Lender`s Archived', type: 'Lender'},
            { value: 'lender_leadsmanagement', label: 'Lender`s Leads Managemnet', type: 'Lender'},
            { value: 'my_leads', label: 'Lender`s Purchased Lead', type: 'Lender'},
            { value: 'transactionPage', label: 'Lender`s Purchase History', type: 'Lender'},
            { value: 'showMySalesPersonPage', label: 'Lender`s Sales People', type: 'Lender'},
            { value: 'showMyAssignedLeadPage', label: 'Lender`s Assigned Leads', type: 'Lender'},
            { value: 'lender_recent_applicationSt', label: 'Lender`s Merchant Applications', type: 'Lender'},
            { value: 'users_resquestList', label: 'Lender`s Buy Leads', type: 'Merchant'},
            { value: 'onlineUserSt', label: 'Lender`s Online Users', type: 'Lender'},
            { value: 'archiveNotificationSt', label: 'Lender`s Archived Notifications', type: 'Lender'},
            { value: 'showMyBrokersPage', label: 'Lender`s My Brokers', type: 'Lender'},
            { value: 'enablebrokeraccountmng', label: 'Lender`s Account Managment', type: 'Lender'},
            { value: 'showMembershipsLender', label: 'Lender`s Membership', type: 'Lender'},
            { value: 'showTemplatePage', label: 'Lender`s Templates', type: 'Lender'},
            { value: 'showLenderUnderWritingSt', label: 'Lender`s Underwriting Process', type: 'Lender'},
            { value: 'purchasedrecent_applicationSt', label: 'Lender`s Revenu Summary', type: 'Lender'},
            { value: 'showMyMatchupsPage', label: 'Lender`s Enquiry', type: 'Lender'},            

            { value: 'company_userList', label: 'Company`s Users list', type: 'Company'},
            { value: 'showLeadsList-all', label: 'Company`s Leads list', type: 'Company'},
            { value: 'showAllInvestorsPage', label: 'Company`s All Investors', type: 'Company'},
            { value: 'showLeadsList-funded', label: 'Company`s Funded Lead', type: 'Company'},
            { value: 'showLeadsList-sold', label: 'Company`s Sold Lead', type: 'Company'},
            { value: 'showLendersList-active', label: 'Company`s Lenders Active', type: 'Company'},
            { value: 'showLendersList-inactive', label: 'Company`s Lenders Inactive', type: 'Company'},
            { value: 'company_transactionList', label: 'Company`s Monthly Earnings', type: 'Company'},
            { value: 'company_transactionList', label: 'Company`s Yearly Earnings', type: 'Company'},
            { value: 'companyAiQuestionsCategory', label: 'Company`s AI Bank Questions', type: 'Company'},
            { value: 'showTagsPageSt', label: 'Company`s Highlighted Keywords', type: 'Company'},
            { value: 'showMyTeamMemberPage', label: 'Company`s Team Members', type: 'Company'},
            { value: 'company_useraccountlist', label: 'Company`s User Connected Bank Account', type: 'Company'},
            { value: 'company_lenderaccountlist', label: 'Company`s Lender Connected Bank Account', type: 'Company'},
            { value: 'recent_applicationSt', label: 'Company`s Recent Application', type: 'Company'},
            { value: 'inbox_st', label: 'Company`s Inbox', type: 'Company' },
            { value: 'CreditcardrequestSt', label: 'Company`s Credit Card Request', type: 'Company' },
            { value: 'InsurancerequestSt', label: 'Insurance Request', type: 'Company'},

            //{ value: 'showTransactionsList', label: 'Company`s Purchased Leads', type: 'Company'},
            //{ value: 'showMyInterests', label: 'My interests'},  
            
            { value: 'salesAssignedLeadSt', label: 'Sale People`s Assigned Leads',type: 'Sales Person'},
            { value: 'archiveNotificationSt', label: 'Sale People`s Archived Notifications',type: 'Sales Person'},
            { value: 'onlineUserSt', label: 'Sale People`s Online Users',type: 'Sales Person'},
            { value: 'salesCancelLeadSt', label: 'Sale People`s Cancelled Leads',type: 'Sales Person'},
                        
            { value: 'users_resquestList', label: 'Broker`s Leads', type: 'Broker'},
            { value: 'my_leads', label: 'Broker`s Purchased Lead', type: 'Broker'},
            { value: 'transactionPage', label: 'Broker`s Purchase History', type: 'Broker'},
            { value: 'myinvites', label: 'Broker`s My Invites', type: 'Broker'},
            { value: 'broker_mymerchant', label: 'Broker`s Posted Leads', type: 'Broker'},
            { value: 'enablebrokeraccountmng', label: 'Broker`s Account Management', type: 'Broker'},
            { value: 'showMembershipsBroker', label: 'Broker`s Membership', type: 'Broker'},
            { value: 'userApplyForm', label: 'Broker`s Apply for Merchant', type: 'Broker'},
            { value: 'archiveNotificationSt', label: 'Broker`s Archived Notifications', type: 'Broker'},
            { value: 'my_archive', label: 'Broker`s Archived Leads', type: 'Broker'},
            { value: 'showTemplatePage', label: 'Broker`s Templates', type: 'Broker'},
        ],

        user_type_options :[            
            { value: 'choose', label: 'Before Login'},
            { value: 'user', label: 'User'},
            { value: 'lender', label: 'Lender'},
            { value: 'investor', label: 'Investor'},        
            { value: 'broker', label: 'Broker'},        
            { value: 'salesperson', label: 'Sales Person'},        
            { value: 'company', label: 'Company'},        
        ],
        user_typeOptions :[            
            { value: 'guest', label: 'Before Login'},
            { value: 'user', label: 'User'},
            { value: 'lender', label: 'Lender'},
            { value: 'investor', label: 'Investor'},        
            { value: 'broker', label: 'Broker'},        
            { value: 'salesperson', label: 'Sales Person'},        
            { value: 'company', label: 'Company'},        
        ],
        pageOption :[
            {value:'applicationFormSt', label:'Guest Loan Application Form', type:"guest"},
            {value:'commonMembershipPage', label:'Guest Membership Page', type:"guest"},
            {value:'users_resquestList', label:'Guest Lead Page', type:"guest"},

            { value: 'membershipPage', label: 'Merchant`s membership page', type: 'user'},
            { value: 'applicationFormSt', label: 'Merchant Loan Application Form', type: 'user'},
           
            { value: 'showUsersAppList', label: 'User`s request', type: 'user'},
            { value: 'showLeadResponse', label: 'User`s lead response', type: 'user'},
            { value: 'showCreditCheck', label: 'Credit check', type: 'user'},        
            { value: 'showUploadDocuments', label: 'User`s upload documents', type: 'user'},
            { value: 'showUserstheAdditionalform', label: 'User`s complete loan form', type: 'user'},
            { value: 'lenderMainTab', label: 'Lender Main Tab', type: 'user'},
            { value: 'leadMainTab', label: 'Lead Main Tab', type: 'user'},
            { value: 'investorMainTab', label: 'Investor Main Tab', type: 'user'},

            { value: 'showUsersAppList', label: 'Investor`s Leads', type: 'investor'},
            { value: 'showInterests', label: 'Investor`s Interests', type: 'investor'},
            { value: 'showInvLender', label: 'Investor`s My lenders', type: 'investor'},
            { value: 'showInvRequest', label: 'Investor`s Lenders Request', type: 'investor'},
            { value: 'showInviteLender', label: 'Investor`s Lenders Invitation', type: 'investor'},

            { value: 'showUsersAppList', label: 'Lender`s Buy Leads', type: 'lender'},
            { value: 'showMyInvestors', label: 'Lender`s My Investor', type: 'lender'},
            { value: 'showArchived', label: 'Lender`s Archived', type: 'lender'},
            { value: 'showMyLeadRequest', label: 'Lender`s Lead', type: 'lender'},
            { value: 'showTransaction', label: 'Lender`s History', type: 'lender'},

            { value: 'showUsersList', label: 'Company`s Users list',type: 'company'},
            { value: 'showLeadsList-all', label: 'Company`s Leads list', type: 'company'},
            { value: 'showLeadsList-sold', label: 'Company`s Sold Lead', type: 'company'},
            { value: 'showLeadsList-funded', label: 'Company`s Funded Lead', type: 'company'},
            { value: 'showAllInvestors', label: 'Company`s All Investors', type: 'company'},
            { value: 'showLendersList-active', label: 'Company`s Lenders Active', type: 'company'},
            { value: 'showLendersList-inactive', label: 'Company`s Lenders Inactive', type: 'company'},
            { value: 'showTransactionsList', label: 'Company`s Monthly Earnings', type: 'company'},
            { value: 'showTransactionsList', label: 'Company`s Yearly Earnings', type: 'company'},
            { value: 'showTransactionsList', label: 'Company`s Purchased Leads', type: 'company'}


        ],
        advertisement_linktype:[
            { value: 'external', label: 'External' },
            { value: 'internal', label: 'Internal' },
            // { value: 'offer', label: 'Offer' },
        ],

        before_login_ads_options :[            
            { value: 'lenderMainTab', label: 'Lender Page'},
            { value: 'leadMainTab', label: 'Lead Page'},
            { value: 'investorMainTab', label: 'Investor Page'},   
            { value: 'triggerForm', label: 'Loan application form'},     
        ],

        dashboard_blocks :[            
            { value: 'block1', label: 'Block A', columncount:4},
            { value: 'block2', label: 'Block B', columncount:4},
            { value: 'block3', label: 'Block C', columncount:3}, 
            { value: 'block4', label: 'Block D', columncount:4},  
        ],

        // user_ads_options :[
        //     { value: 'showUsersAppList', label: 'User`s request'},
        //     { value: 'showLeadResponse', label: 'User`s lead response'},
        //     { value: 'showCreditCheck', label: 'Credit check'},
        //     { value: 'showUserstheAppform', label: 'Loan application form'},
        //     { value: 'showUploadDocuments', label: 'User`s upload documents'},
        //     { value: 'showUserstheAdditionalform', label: 'User`s complete loan form'},
        //     { value: 'lenderMainTab', label: 'Lender Page'},
        //     { value: 'leadMainTab', label: 'Lead Page'},
        //     { value: 'investorMainTab', label: 'Investor Page'},        
        // ],

        user_ads_options :[
            { value: 'showUsersAppList', label: 'Request'},
            { value: 'showLeadResponse', label: 'Lender Offers'},
            { value: 'showCreditCheck', label: 'Credit Checks'},
            { value: 'showUsersUnderwriting', label: 'Underwriting Process'},
            { value: 'showPurchasedResponse', label: 'Purchased Lenders'},
            { value: 'showOnlineUserList', label: 'Online Users'},
            { value: 'showUserstheAppform', label: 'Loan application form'},
            { value: 'paymentcards', label: 'Payment Methods'},
            { value: 'showRepaymentTracking', label: 'Loan Details'},

            // { value: 'showUploadDocuments', label: 'User`s upload documents'},
            // { value: 'showUserstheAdditionalform', label: 'User`s complete loan form'},
            // { value: 'lenderMainTab', label: 'Lender Page'},
            // { value: 'leadMainTab', label: 'Lead Page'},
            // { value: 'investorMainTab', label: 'Investor Page'},        
        ],

        investor_ads_options :[            
            { value: 'showUsersAppList', label: 'Investor`s Leads'},
            { value: 'showInterests', label: 'Investor`s Interests'},
            { value: 'showInvLender', label: 'Investor`s My lenders'},                          
        ],

        lender_ads_options :[           
            { value: 'showUsersAppList', label: 'Lender`s Buy Leads'},
            { value: 'showMyInvestors', label: 'Lender`s My Investor'},
            { value: 'showArchived', label: 'Lender`s Archived'},
            { value: 'showMyLeadRequest', label: 'Lender`s Lead'},                  
        ],

        company_ads_options :[           
            { value: 'showUsersList', label: 'Company`s Users list'},
            { value: 'showLeadsList-all', label: 'Company`s Leads list'},
            { value: 'showLeadsList-sold', label: 'Company`s Sold Lead'},
            { value: 'showLeadsList-funded', label: 'Company`s Funded Lead'},
            { value: 'showAllInvestors', label: 'Company`s All Investors'},                  
        ],

        guide_user_type_options :[                       
            { value: 'user', label: 'Merchant'},
            { value: 'lender', label: 'Lender'},
            { value: 'investor', label: 'Investor'},        
            { value: 'broker', label: 'Broker'},        
            { value: 'salesperson', label: 'Sales Person'},        
            { value: 'company', label: 'Company'},        
        ],
        
        sales_ads_options :[           
            { value: 'showAssignedLeads', label: 'Sale person`s Assigned Leads'},                             
        ],
       
        broker_ads_options :[           
            { value: 'showUsersAppList', label: 'Broker`s Buy Leads'},
            { value: 'showMyLeadRequest', label: 'Broker`s Leads'},
        ],

        discount_option:[
            { value: 'percentage', label: 'Percentage' },
            { value: 'standard', label: 'Standard' },
        ],
		 shortcuticon_options :[     
            { value: 'ai', label: 'AI' },
            { value: 'profile', label: 'Profile' },            
            { value: 'dashboard', label: 'Dashboard'},  
            { value: 'financial_advisor', label: 'Financial Advisor'},  
            { value: 'ads', label: 'Advertisement'},   
            { value: 'guide', label: 'Guide'},        
        ],
		sidebar_ai_options :[     
            { value: 'triggerTabScreen', label: 'AI Chat' },
            { value: 'triggerTabScreen', label: 'Lenders' },
            { value: 'triggerTabScreen', label: 'Leads' },
            { value: 'triggerTabScreen', label: 'Investors' },
            { value: 'triggerTabScreen', label: 'Guide'},        
            { value: 'triggerTabScreen', label: 'Dashboard' },
            { value: 'showAddPage', label: 'Advertisement'},   
            { value: 'showApplyLoanPageSt', label: 'Apply for a Loan'},   
            { value: 'showCommonMembershipSt', label: 'Membership Plans'},   
        ],
        tab_login_type:[
            { value: 'All', label: 'All' },
            { value: 'Merchant', label: 'Merchant' },
            { value: 'Lender', label: 'Lender' },
            { value: 'Investor', label: 'Investor' },
            { value: 'Broker', label: 'Broker' },
            { value: 'Sales People', label: 'Sale People' },
            { value: 'Company', label: 'Company' },
            { value: 'Guest', label: 'Guest' },
        ],
        tab_access_type:[
            { value: 'All', label: 'All' },
            { value: 'AI', label: 'AI' },
            { value: 'Main Tab', label: 'Main Tab' },          
        ],
        domainList_option:domainList(),
        loantype_option:[            
            { value: 'Business', label: 'Business' },
            { value: 'Education', label: 'Education' },
            { value: 'Personal', label: 'Personal' },
            { value: 'Startup', label: 'Startup' },
            { value: 'Others', label: 'Others' },
        ],
        leadsType_option:[            
            { value: '', label: 'All' },
            { value: 'funded', label: 'Funded Leads' },
            { value: 'sold', label: 'Sold Leads' },
        ],
		login_type:[
            { value: 'merchant', label: 'Merchant' },
            { value: 'lender', label: 'Lender' },
            { value: 'investor', label: 'Investor' },
            { value: 'company', label: 'Company' },
        ],
        card_type:[
            { value: 'personal', label: 'Personal' },
            { value: 'business', label: 'Business' }
        ],
        amountType_options : [
            { value: "K", label: "K - Thousand " },
            { value: "M", label: "M - Million " },
            { value: "B", label: "B - Billion " },
            { value: "T", label: "T - Trillion " },
        ],
        // amountType_options : [
        //     { value: "K", label: "K - Thousand (1,000)" },
        //     { value: "M", label: "M - Million (1,000,000)" },
        //     { value: "B", label: "B - Billion (1,000,000,000)" },
        //     { value: "T", label: "T - Trillion (1,000,000,000,000)" },
        // ]
    },
    Capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
        }
};



